import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Space, Tag } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';
import PermWrapper from '@/components/PermWrapper';
import { toText } from '..';
import Modal from './Modal';

function AutoPolicy({ data, commonProps }) {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Descriptions
        title='自动策略'
        bordered
        actions={
          <PermWrapper resource='pulsar:namespace:list:config'>
            <Button onClick={() => setVisible(true)} theme='default' variant='outline' size='small'>
              修改
            </Button>
          </PermWrapper>
        }
      >
        <Descriptions.Item
          label='Topic'
          value={
            <Space size='small'>
              {data.allowAutoTopicCreation ? (
                <>
                  <Tag theme='success' variant='light' size='small'>
                    自动
                  </Tag>
                  <Tag theme='success' variant='light' size='small'>
                    {data.autoTopicCreationType}
                  </Tag>

                  {data.autoTopicCreationType === 'partitioned' && (
                    <Tag theme='success' variant='light' size='small'>
                      分区数: {toText(data.defaultNumPartitions)}
                    </Tag>
                  )}
                </>
              ) : (
                <Tag theme='default' variant='light' size='small'>
                  手动
                </Tag>
              )}
            </Space>
          }
        />
        <Descriptions.Item
          label='订阅者'
          value={
            <Tag
              theme={data.allowAutoSubscriptionCreation ? 'success' : 'default'}
              variant='light'
              size='small'
            >
              {data.allowAutoSubscriptionCreation ? '自动' : '手动'}
            </Tag>
          }
        />
        <Descriptions.Item
          label='Schema'
          value={
            <Tag
              theme={data.isAllowAutoUpdateSchema ? 'success' : 'default'}
              variant='light'
              size='small'
            >
              {data.isAllowAutoUpdateSchema ? '自动' : '手动'}
            </Tag>
          }
        />
      </Descriptions>
      <Modal
        visible={visible}
        detail={data}
        commonProps={commonProps}
        handleClose={() => setVisible(false)}
      />
    </>
  );
}

export default connect((state) => ({
  data: state.namespace.proPolices,
}))(AutoPolicy);
